import React, { Fragment, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import SetPasswordPage from 'modules/Onboarding/Components/ActivateAccount/SetPasswordPage/SetPasswordPage.js'

const AUTH_URL = process.env.AUTH_URL

const ActivateStudent = ({
  studentDetails,
  getStudentData,
  campusDetails,
  getCollege,
  sendOtp,
  checkOtp,
  resetPwd,
  updateCurrentState,
  updateStatusPending,
}) => {
  const params = useParams()
  const navigate = useNavigate()
  const studentId = params.studentId
  const [goingToLogin, setGoingToLogin] = useState(false)

  const currentState = studentDetails?.currentState
  // currentState is only known once getStudentData resolves. -1 / 0 / 1 are
  // pre-password states; SetPasswordPage advances the student to state 2.
  const stateKnown = currentState !== undefined && currentState !== null
  const isNewUser =
    currentState === -1 || currentState === 0 || currentState === 1

  const redirectToLogin = () => {
    setGoingToLogin(true)
    // replace() (not href) so Back doesn't return to this activate page.
    try { window.location.replace(AUTH_URL) } catch (_) { window.location.href = AUTH_URL }
  }

  useEffect(() => {
    getStudentData(studentId)
  }, [studentId])

  useEffect(() => {
    if (studentDetails?.instituteCampusId) {
      getCollege(studentDetails?.instituteCampusId)
    }
  }, [studentDetails])

  // Existing user -> login. (New users stay and see SetPasswordPage below.)
  useEffect(() => {
    if (stateKnown && !isNewUser) {
      redirectToLogin()
    }
  }, [currentState])

  // Safety net: if the student fetch never resolves (seen on iPhone — iOS Mail's
  // in-app browser / ITP can block or drop the request), DON'T fall back to the
  // set-password page (the reported bug — a returning user wrongly sent to set
  // password). Default an unknown state to LOGIN instead.
  //
  // Keyed on `stateKnown` (NOT `[]`): once the fetch resolves — for a NEW user
  // too — this effect re-runs, the cleanup clears the pending timer, and the
  // early-return stops it from re-arming. Using `[]` here captured a stale
  // `stateKnown === false` from the first render, so the timer fired ~6s later
  // and wrongly bounced brand-new users (currentState 0/-1) to login even after
  // their data had loaded.
  useEffect(() => {
    if (stateKnown) return
    const t = setTimeout(() => {
      redirectToLogin()
    }, 6000)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateKnown])

  // Render set-password ONLY for a confirmed new user. While the state is still
  // loading (or we're redirecting an existing user to login), show a spinner —
  // never default to set-password.
  if (isNewUser) {
    return (
      <Fragment>
        <SetPasswordPage
          studentDetails={studentDetails}
          resetPwd={resetPwd}
          updateCurrentState={updateCurrentState}
          updateStatusPending={updateStatusPending}
          studentId={studentId}
        />
      </Fragment>
    )
  }

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '14px',
        color: '#475569',
        fontSize: '15px',
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          border: '3px solid #e2e8f0',
          borderTopColor: '#2563eb',
          borderRadius: '50%',
          animation: 'pl-spin 0.8s linear infinite',
        }}
      />
      <span>{goingToLogin ? 'Redirecting to login…' : 'Loading…'}</span>
      <style>{`@keyframes pl-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  )
}

export default ActivateStudent
